// src/components/WinRateCalculator/Presets.jsx
import React from "react";
import ProfileCard from "./ProfileCard"; // Import the updated ProfileCard

/**
 * Displays a list of profit profiles that can be selected to load into the calculator
 * or applied to an account.
 * @param {object[]} profiles - Array of profile objects.
 * @param {function} onSelect - Callback function executed to load a profile into the calculator.
 * @param {string} [accountId] - Optional account ID for the "Apply to Account" functionality in ProfileCard.
 */
export default function Presets({ profiles, onSelect, accountId }) {
  if (!profiles || profiles.length === 0) {
    return <p className="text-sm text-textSecondary mt-4">No presets available.</p>; {/* Updated text color */}
  }

  return (
    <div className="mt-6">
      <h3 className="text-lg font-medium mb-3 text-textPrimary">Profit Profiles</h3> {/* Updated text color */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 lg:grid-cols-2 gap-4"> {/* Adjusted grid for cards */}
        {profiles.map((profile) => (
          <ProfileCard
            key={profile.id || profile.name}
            profile={profile}
            onLoadToCalculator={onSelect} // Pass the onSelect callback to ProfileCard
            accountId={accountId}         // Pass accountId for the "Apply to Account" feature
          />
        ))}
      </div>
    </div>
  );
}
